module.exports = __webpack_public_path__ + "media/images/arrows-54da5e33befdc58600ced563abdb039f.svg";